<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    <center> <v-btn v-if="!sideBySide" class="info no-display" @click="save_issue_date()" small :loading="loader">Save Issue Date</v-btn></center>
    <div
      :class="
        sideBySide ? 'icard-container side-by-side' : 'icard-container stacked'
      "
      v-for="(stud_data, ind) in icard_data"
      :key="ind"
    >
      <div v-if="icard_data != ''" style="background-color: white">
        <div>
          <div class="row" style="background-color: white">
            <div class="ml-1" style="font-size: 0.9em">
              <img
                :src="common_data.logo"
                height="60"
                width="80"
                alt="logo"
                style="margin-left: 25px"
              />
            </div>
            <div class="heading" style="width: 340px; line-height: 110%">
              <div
                class="text-right"
                style="font-weight: bold; font-family: Tahoma"
              >
                <h5>Pimpri Chinchwad Education Trust's</h5>
                <h3 class="header">S.B. PATIL PUBLIC SCHOOL, RAVET, PUNE</h3>
                <h5>CBSE Affiliation No:-1130534</h5>
                <h5>NABET Accredited, QS I-GAUGE Diamond+ Rated</h5>
                <h5 style="margin-left: -70px; font-size: 10.55px;">British Council Recognition of International Dimension in Schools</h5>
              </div>
            </div>
          </div>
          <v-img
            style="
              background-color: white;
              width: 450px;
              height: 202px;
              padding: 0px !important;
              margin: 0px !important;
            "
            :src="common_data.watermark"
          >
            <hr style="width: 100%; margin-top: 1px;" />
            <v-row dense>
              <img
                :src="stud_data.profile_photo_path"
                class="ml-3 box1 mt-1"
                style="width: 22%; height: 110px"
              />
              <div
                class="ml-5 mt-1"
                style="font-size: 0.9em; font-family: tahoma; line-height: 130%"
              >
                <b> Academic Year :-</b><b> {{ stud_data.ay }}</b
                ><br />
                <b> Name :- </b><b> {{ stud_data.name }}</b
                ><br />
                <b> Grade :- </b><b> {{ stud_data.std_display_name }}</b>
                <b class="ml-5"> Div :- </b><b> {{ stud_data.div }}</b>
                <br />
                <b> House :- </b
                ><b v-if="stud_data.house !== null && stud_data.house !== ''">
                  {{ stud_data.house }}</b
                >
                <b v-else> -</b><br />
                <b> Contact No. :- </b><b> {{ stud_data.both_mobile_no }}</b
                ><br />
              </div>
            </v-row>
            <v-row>
              <div class="white--text principal-sign col-8 mt-2">
                <img
                  :src="common_data.sign"
                  alt="logo"
                  style="width: 25%; height: auto"
                  class="ml-2"
                />
                <br />
                <b class="ml-2" style="text-transform: uppercase">Principal</b>
              </div>
              <div
                  class="white--text col-4"
                  style="
                      align-self: end;
                      text-align: center;
                      margin-top: -10px;
                  "
                >                  
                  <b>{{ stud_data.prn }}</b>
                  <img
                      src="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/Role_link_icons/sbpps/1/rids_year_cmyk(14-08-2025)-np-02(1)(1)99rpcrtq8n.png"
                      style="
                          width: 50px;
                          height: 50px;
                          object-fit: contain;
                          display: block;
                          margin: 0 auto 2px auto;                          
                      "
                  />
              </div>
            </v-row>
          </v-img>
        </div>
      </div>
      <!-- back card -->
      <div
        class="pagebreak"
        style="background-color: white; font-family: tahoma"
      >
        <div v-if="icard_data != ''" style="width: 26.5rem" class="ml-2">
          <div style="font-size: 12px; line-height: 134%" class="mt-1">
            <v-row class="p-0" style="margin-top: -2px" dense>
              <div class="pl-1">
                <b> Date of Birth :-</b><b> {{ stud_data.stud_dob }} </b>
              </div>
              <div class="" style="margin-left: 123px">
                <b> Blood Group :-</b><b>{{ stud_data.stud_blood_group }}</b>
              </div>
            </v-row>
            <div style="margin-top: -2px; height: 7px">
              <b> Address :- </b><b> {{ stud_data.stud_address }}</b>
            </div>
            <br />
            <div style="margin-top: 15px">
              <b> Parent Name :- </b
              ><b> {{ stud_data.parent_name_stud_icard }}</b>
            </div>
            <div class="row">
              <div class="pl-3" style="width: 305px; font-size: 11px">
                <b> Email :- </b><b> {{ stud_data.email }}</b>
              </div>
              <div>
                <b> Mobile :-</b><b> {{ stud_data.stud_contact }}</b>
              </div>
            </div>
          </div>
          <hr style="margin-top: 2px; margin-bottom: -10px" />
          <b style="font-size: x-small; margin-top: -10px; padding-top: -10px"
            >Important Points</b
          >
          <v-row
            style="font-size: 10px"
            dense
            class="ml-3"
            v-for="(i, index) in common_data.instruction"
            :key="index"
          >
            <b>{{ index + 1 }} . {{ i.topic }}</b>
          </v-row>
          <center>
            <div class="barcode">
              <barcode
                height="12"
                width="2"
                v-model="stud_data.prn"
                v-bind:value="stud_data.prn"
              >
              </barcode>
            </div>
          </center>
          <div
            style="
              background: #0095cb;
              margin-left: -8px;
              width: 450px;
              font-size: 11px;
              margin-top: -5px;
            "
          >
            <div class="pt-1">
              <center>
                <b>
                  {{ common_data.school_address }} <br />
                  School Contact No. :- {{ common_data.school_contact }} <br />
                  Email :- {{ common_data.school_email
                  }}<span class="ml-5">
                    Website :- {{ common_data.website }}</span
                  >
                </b>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: {
    sideBySide: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    barcode: VueBarcode,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    comp_load: false,
    stud_list: null,
    radios: null,
    stud_data: null,
    child_data: null,
    icard_data: [],
    std: null,
    div: null,
    ay: null,
    common_data: null,
    status: null,
    prn: null,
    loader:false,
  }),
  mounted() {
    this.prn = JSON.parse(localStorage.getItem("prn"));
    this.onload();
  },

  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    onload() {
      const data = {
        learners: this.prn,
        for: "specific",
        usertype: "Student",
      };
      axios
        .post("/Icard/getIcardSpecificStudentsforSbpps", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data = res.data.icard_data;
            this.common_data = res.data.common_data;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          }
        });
    },
    save_issue_date(){
                const data = {
                    learners: this.prn,
                };
                this.loader = true
                axios
                    .post("/Icard/saveIcardIssueDate", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Save successfully");
                            this.loader = false
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.loader = false
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.loader = false
                    })
                    .finally(() => {
                        this.loader = false
                    });
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>

<style scoped>
.icard-container.side-by-side {
  display: flex;
  flex-direction: row;
  gap: 50px;
}

.icard-container.stacked {
  display: flex;
  flex-direction: column;
}
@media (max-width: 600px) {
  .icard-container.side-by-side {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
}
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
    font-size: xx-large !important;
  }

  v-card {
    border: none !important;
  }

  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .pagebreak {
    page-break-before: always !important;
  }

  .empimg span {
    font-size: 10px !important;
  }

  .principal-sign {
    font-size: small;
  }

  .heading {
    font-size: small !important;
    height: 72px !important;
  }

  @page {
    margin-top: 0.12cm !important;
  }

  .first_page {
    margin-top: 1mm;
  }

  @page {
    margin: 0mm;
    size: 85mm 53mm;
  }
  .barcode {
    margin-top: -1px;
    margin-bottom: -5px;
  }
}

.box1 {
  border: 2px solid black;
}
.barcode {
  margin-top: -1px;
  margin-bottom: -2px;
}

.empimg {
  position: relative;
}
.empimg span {
  font-size: small;
}
</style>
